import { EMMA_EVENTS } from 'emma-common-ts/emma';

const singleEventLabels: { [key in EMMA_EVENTS]?: string } = {
  [EMMA_EVENTS.AUTO_EVENT]: $localize`Evento automático`,
  [EMMA_EVENTS.END_SESSION]: $localize`Fin sesión`,
  [EMMA_EVENTS.FIRST_LOGIN]: $localize`Primer login`,
  [EMMA_EVENTS.INSTALL]: $localize`Instalación`,
  [EMMA_EVENTS.LOGIN]: $localize`Login`,
  [EMMA_EVENTS.REGISTER]: $localize`Registro`,
  [EMMA_EVENTS.SESSION]: $localize`Sesión`,
  [EMMA_EVENTS.TRANSACTION]: $localize`Venta`,
  [EMMA_EVENTS.RETARGETING_OPEN]: $localize`Apertura de retargeting`,
};

const pluralEventLabels: { [key in EMMA_EVENTS]?: string } = {
  [EMMA_EVENTS.AUTO_EVENT]: $localize`Eventos automáticos`,
  [EMMA_EVENTS.END_SESSION]: $localize`Fines sesión`,
  [EMMA_EVENTS.FIRST_LOGIN]: $localize`Primeros login`,
  [EMMA_EVENTS.INSTALL]: $localize`Instalaciones`,
  [EMMA_EVENTS.LOGIN]: $localize`Logins`,
  [EMMA_EVENTS.REGISTER]: $localize`Registros`,
  [EMMA_EVENTS.SESSION]: $localize`Sesiones`,
  [EMMA_EVENTS.TRANSACTION]: $localize`Ventas`,
  [EMMA_EVENTS.RETARGETING_OPEN]: $localize`Aperturas de retargeting`,
};

export const getEventNameI18n = (eventName: EMMA_EVENTS | string, shouldBePlural = false): string => {
  return (
    (shouldBePlural
      ? pluralEventLabels[eventName as EMMA_EVENTS]
      : singleEventLabels[eventName as EMMA_EVENTS]) || eventName
  );
};
